/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-11-24 20:23:39
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-01-26 17:58:32
 * @FilePath: /work.xhey.top/src/pages/photov2/components/GuessYouWantSearch.tsx
 * @Description: 猜你想搜展示组件
 */
import React from 'react'
import { Checkbox, Tooltip } from 'antd'
import type { SuggestedSearchWord } from '../../../slices/photoFilterSlice'

interface GuessYouWantSearchProps {
  suggestedSearchWords: Array<SuggestedSearchWord & Record<string, any>>
  highlightKeyword?: string
  onToggle: (index: number) => void
  searchType?: '普通猜你想搜' | '向量化猜你想搜'
}

const GuessYouWantSearch: React.FC<GuessYouWantSearchProps> = ({
  suggestedSearchWords,
  highlightKeyword = '',
  onToggle
}) => {
  if (!suggestedSearchWords.length) {
    return null
  }

  // 找到用户输入的关键词（被标记为 isLocked）的索引（如果存在）
  const userKeywordIndex = suggestedSearchWords.findIndex(
    (word) => word.isLocked
  )
  const hasUserKeyword = userKeywordIndex !== -1

  return (
    <div
      className="guess-you-want-search"
      style={{
        height: 52,
        display: 'flex',
        alignItems: 'center',
        width: '100%'
      }}
    >
      {/* 如果存在用户自己输入的关键词，先单独展示在前面 */}
      {hasUserKeyword && (
        <>
          <span style={{ marginRight: 8, color: '#848484' }}>
            已展示搜索结果：
          </span>
          {(() => {
            const item = suggestedSearchWords[userKeywordIndex]
            const checkedCount = suggestedSearchWords.filter(
              (word) => word.isChecked
            ).length
            // 只有当存在用户关键词时才强制保留至少一项（和之前逻辑一致）
            const shouldPreventToggle = hasUserKeyword
              ? item.isChecked && checkedCount === 1
              : false
            return (
              <Tooltip
                title={shouldPreventToggle ? '请至少保留一个搜索词' : undefined}
                mouseEnterDelay={0.2}
              >
                <span>
                  <Checkbox
                    key={`${item.word}-user`}
                    checked={item.isChecked}
                    onChange={() => {
                      if (shouldPreventToggle) return
                      onToggle(userKeywordIndex)
                    }}
                  >
                    {item.word.split('').map((char, charIndex) => (
                      <span
                        key={`${item.word}-user-${charIndex}`}
                        style={{ color: '#848484' }}
                      >
                        {char}
                      </span>
                    ))}
                  </Checkbox>
                </span>
              </Tooltip>
            )
          })()}
          <span style={{ marginRight: '8px', color: '#C4C4C4' }}>|</span>
        </>
      )}

      {/* 其余的候选词仍然显示在“猜你想搜”后面 */}
      <span style={{ marginRight: 8, color: '#848484' }}>猜你想搜：</span>
      {suggestedSearchWords.map((item, index) => {
        if (index === userKeywordIndex) return null
        const checkedCount = suggestedSearchWords.filter(
          (word) => word.isChecked
        ).length
        const shouldPreventToggle = hasUserKeyword
          ? item.isChecked && checkedCount === 1
          : false
        return (
          <Tooltip
            key={`guess-item-${index}-${item.word}`}
            title={shouldPreventToggle ? '请至少保留一个搜索词' : undefined}
            mouseEnterDelay={0.2}
          >
            <span>
              <Checkbox
                checked={item.isChecked}
                style={{ marginRight: 16 }}
                onChange={() => {
                  if (shouldPreventToggle) return
                  onToggle(index)
                }}
              >
                {item.word.split('').map((char, charIndex) => (
                  <span
                    key={`${item.word}-${index}-${charIndex}`}
                    style={{
                      color: highlightKeyword.includes(char)
                        ? '#0093FF'
                        : '#000000A6'
                    }}
                  >
                    {char}
                  </span>
                ))}
              </Checkbox>
            </span>
          </Tooltip>
        )
      })}
    </div>
  )
}

export default GuessYouWantSearch
